module.exports = __webpack_public_path__ + "img/19.42da9e06.jpg";